<template>
  <div class="container">
    <div class="presonal-title">
      <span> {{ $t('lang.external.personal.content.four.已学课程') }}</span>
    </div>
    <el-table :data="tableData" style="width: 100%">
      <el-table-column
        type="index"
        :label="$t('lang.external.personal.content.four.序号')"
        align="center"
        width="100"
      />
      <el-table-column
        prop="courseName"
        :label="$t('lang.external.personal.content.four.实验名称')"
        align="center"
        min-width="40%"
      />
      <el-table-column
        prop="spendSecond"
        :label="$t('lang.external.personal.content.four.时长')"
        align="center"
        min-width="20%"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.spendSecond | time }}</span>
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('lang.external.personal.content.four.操作')"
        align="center"
        min-width="20%"
      >
        <template slot-scope="scope">
          <el-button
            type="text"
            @click="learne(scope.row.course_id, scope.row.studyStatus)"
          >
            <span :class="scope.row.over ? 'color-b' : 'color-o'">
              {{
                scope.row.studyStatus === 1
                  ? $t('lang.external.personal.content.four.重新学习')
                  : $t('lang.external.personal.content.four.继续学习')
              }}
            </span>
          </el-button>
        </template>
      </el-table-column>
      <div slot="empty">
        <el-empty
          :description="$t('lang.external.personal.content.four.暂无数据')"
        ></el-empty>
      </div>
    </el-table>
  </div>
</template>

<script>
import { studied, studyAgainR } from '@/api/personalCenter/index.js'
import { formatLan } from '@/utils/lanFormat'
export default {
  name: 'learned',
  components: {},
  props: [],
  data() {
    return {
      tableData: [],
    }
  },
  watch: {},
  computed: {},
  created() {
    this.getStudied()
  },
  mounted() {},
  methods: {
    getStudied() {
      studied().then((res) => {
        const { data } = res
        console.log(res)
        console.log(JSON.stringify(data[0].courseName))
        let array = []
        for (let i = 0; i < data.length; i++) {
          data[i]['courseName'] = formatLan(data[i]['courseName'])
          array.push(data[i])
        }
        this.tableData = array
      })
    },
    learne(id, studyStatus) {
      window.localStorage.setItem('expId', id)

      if (studyStatus === 1) {
        studyAgainR(id).then((res) => {
          this.$router.push({ name: 'Experiment', query: { id } })
        })
      } else {
        this.$router.push({ name: 'Experiment', query: { id } })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.container {
  width: 100%;
  .el-table {
    border-radius: 0 0 4px 4px;
  }
}
</style>